import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/search")({
  component: SearchSectionLayout,
});

function SearchSectionLayout() {
  return <Outlet />;
}
